// extracted by mini-css-extract-plugin
export default {"content":"RetroatividadeRenovacao_content__ddOO2","text":"RetroatividadeRenovacao_text__pSL79","ciencia":"RetroatividadeRenovacao_ciencia__Ihq6v"};